module.exports = __webpack_public_path__ + "img/showcase-2.647ad78f.png";